import type { EnterpriseLBAExperienceInterface } from '@/components/Applications/EnterpriseLBAForm/type';
import { accountingFormatNumber, formatNumber } from '@/utils';

interface IExperienceDetailsProps {
  experience: EnterpriseLBAExperienceInterface;
}
export default function ExperienceDetails({ experience }: IExperienceDetailsProps) {
  return (
    <section aria-labelledby='applicant-information-title'>
      <div className='bg-white shadow sm:rounded-lg'>
        <div className='py-5'>
          <div className='px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal'>
            <h2 id='applicant-information-title' className='m-0 text-lg leading-6 font-medium text-primaryColor-normal'>
              Experience
            </h2>
          </div>
        </div>
        <div className='border-t border-gray-200 px-4 py-5 sm:px-6'>
          <h3 className='mb-5'>Company Completed</h3>
          {experience.companyCompleted?.map((project: any) => (
            <dl key={project.id} className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2'>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Project Name</dt>
                <dd className='mt-1 text-sm text-gray-900'>{project.projectName}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Date Completed (U&O)</dt>
                <dd className='mt-1 text-sm text-gray-900'>{project.dateCompleted}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Address</dt>
                <dd className='mt-1 text-sm text-gray-900'>
                  {project.streetAddress}, {project.city}, {project.state}, {project.zipCode}
                </dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Gross Building Area</dt>
                <dd className='mt-1 text-sm text-gray-900'>{formatNumber(project.grossBuildingArea)}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Number of Housing Units</dt>
                <dd className='mt-1 text-sm text-gray-900'>{formatNumber(project.housingUnits)}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Total Development Cost</dt>
                <dd className='mt-1 text-sm text-gray-900'>
                  {accountingFormatNumber({
                    num: project.developmentCost,
                    format: 'en-US',
                    currency: 'USD',
                  })}
                </dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Project Type</dt>
                <dd className='mt-1 text-sm text-gray-900'>
                  {project.projectTypes.map((pType: string) => (
                    <span key={pType}>{pType}, </span>
                  ))}
                </dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Construction Type</dt>
                <dd className='mt-1 text-sm text-gray-900'>
                  {project.constructionTypes.map((cType: string) => (
                    <span key={cType}>{cType}, </span>
                  ))}
                </dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Company's Role</dt>
                <dd className='mt-1 text-sm text-gray-900'>
                  {project.companyRole.map((cType: string) => (
                    <span key={cType}>{cType}, </span>
                  ))}
                  {project.partialOwner && (
                    <span>
                      Partial Owner(
                      {project.partialOwner}%)
                    </span>
                  )}
                </dd>
              </div>
            </dl>
          ))}
        </div>
      </div>
    </section>
  );
}
